import axios from 'axios';
import { polusBaseUrl, POST } from '../../../utils/axios-interceptor';
import { HEADERS } from '../../../utils/constants/commonConstants';
import { getTimeStamp } from '../../../utils/dateUtils';
import { EPF_FILING_DETAILS_URL, MSME_PAYMENT_DELAYS_URL } from './constants';

async function postBefe(url: string, orgId: string, requestPayload: Record<string, string>): Promise<unknown> {
    const response = await axios({
        baseURL: polusBaseUrl,
        url,
        method: POST,
        headers: { [HEADERS.X_ORGANIZATION_ID]: orgId, [HEADERS.X_REQUESTED_ORGANIZATION_ID]: orgId },
        data: { requestPayload },
    });

    return response?.data;
}

export function fetchEpfFilingDetails(orgId: string, startDate: string, endDate: string): Promise<unknown> {
    return postBefe(EPF_FILING_DETAILS_URL, orgId, { requestId: getTimeStamp(), startDate, endDate });
}

export function fetchMsmePaymentDelays(orgId: string): Promise<unknown> {
    return postBefe(MSME_PAYMENT_DELAYS_URL, orgId, { requestId: getTimeStamp() });
}
